/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/details/common"/>
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";
import { IDocumentImportInformation } from "../interfaces";

export const getFlagValue = (flag?: boolean | null) => {
        return flag === undefined || flag === null
            ? null
            : flag
                ? translate("#Core/yes")
                : translate("#Core/no");
    };

export const isCustomFieldTextField1NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldTextCustomField1 !== null && information?.customFieldTextCustomField1 !== "" && information?.customFieldTextCustomField1 !== undefined);

export const isCustomFieldTextField2NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldTextCustomField2 !== null && information?.customFieldTextCustomField2 !== "" && information?.customFieldTextCustomField2 !== undefined);

export const isCustomFieldTextField3NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldTextCustomField3 !== null && information?.customFieldTextCustomField3 !== "" && information?.customFieldTextCustomField3 !== undefined);

export const isCustomFieldTextField4NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldTextCustomField4 !== null && information?.customFieldTextCustomField4 !== "" && information?.customFieldTextCustomField4 !== undefined);

export const isCustomFieldTextField5NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldTextCustomField5 !== null && information?.customFieldTextCustomField5 !== "" && information?.customFieldTextCustomField5 !== undefined);

export const isCustomFieldNumericField1NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldNumericCustomField1 !== null && information?.customFieldNumericCustomField1 !== undefined);

export const isCustomFieldNumericField2NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldNumericCustomField2 !== null && information?.customFieldNumericCustomField2 !== undefined);

export const isCustomFieldNumericField3NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldNumericCustomField3 !== null && information?.customFieldNumericCustomField3 !== undefined);

export const isCustomFieldNumericField4NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldNumericCustomField4 !== null && information?.customFieldNumericCustomField4 !== undefined);

export const isCustomFieldNumericField5NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldNumericCustomField5 !== null && information?.customFieldNumericCustomField5 !== undefined);

export const isCustomFieldBooleanField1NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldBooleanCustomField1 !== null && information?.customFieldBooleanCustomField1 !== undefined);

export const isCustomFieldBooleanField2NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldBooleanCustomField2 !== null && information?.customFieldBooleanCustomField2 !== undefined);

export const isCustomFieldBooleanField3NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldBooleanCustomField3 !== null && information?.customFieldBooleanCustomField3 !== undefined);

export const isCustomFieldBooleanField4NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldBooleanCustomField4 !== null && information?.customFieldBooleanCustomField4 !== undefined);

export const isCustomFieldBooleanField5NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldBooleanCustomField5 !== null && information?.customFieldBooleanCustomField5 !== undefined);

export const isCustomFieldDateTimeField1NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldDateTimeCustomField1 !== null && information?.customFieldDateTimeCustomField1 !== "" && information?.customFieldDateTimeCustomField1 !== undefined);

export const isCustomFieldDateTimeField2NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldDateTimeCustomField2 !== null && information?.customFieldDateTimeCustomField2 !== "" && information?.customFieldDateTimeCustomField2 !== undefined);

export const isCustomFieldDateTimeField3NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldDateTimeCustomField3 !== null && information?.customFieldDateTimeCustomField3 !== "" && information?.customFieldDateTimeCustomField3 !== undefined);

export const isCustomFieldDateTimeField4NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldDateTimeCustomField4 !== null && information?.customFieldDateTimeCustomField4 !== "" && information?.customFieldDateTimeCustomField4 !== undefined);

export const isCustomFieldDateTimeField5NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldDateTimeCustomField5 !== null && information?.customFieldDateTimeCustomField5 !== "" && information?.customFieldDateTimeCustomField5 !== undefined);

export const isCustomFieldCustomListField1NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldListCustomField1Value !== null && information?.customFieldListCustomField1Value !== "" && information?.customFieldListCustomField1Value !== undefined);

export const isCustomFieldCustomListField2NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldListCustomField2Value !== null && information?.customFieldListCustomField2Value !== "" && information?.customFieldListCustomField2Value !== undefined);

export const isCustomFieldCustomListField3NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldListCustomField3Value !== null && information?.customFieldListCustomField3Value !== "" && information?.customFieldListCustomField3Value !== undefined);

export const isCustomFieldCustomListField4NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldListCustomField4Value !== null && information?.customFieldListCustomField4Value !== "" && information?.customFieldListCustomField4Value !== undefined);

export const isCustomFieldCustomListField5NotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.customFieldListCustomField5Value !== null && information?.customFieldListCustomField5Value !== "" && information?.customFieldListCustomField5Value !== undefined);

export const isAnyCustomFieldNotEmpty = (information: IDocumentImportInformation): boolean => 
    isCustomFieldTextField1NotEmpty(information) ||
    isCustomFieldNumericField1NotEmpty(information) ||
    isCustomFieldBooleanField1NotEmpty(information) ||
    isCustomFieldDateTimeField1NotEmpty(information) ||
    isCustomFieldCustomListField1NotEmpty(information) ||
    isCustomFieldTextField2NotEmpty(information) ||
    isCustomFieldNumericField2NotEmpty(information) ||
    isCustomFieldBooleanField2NotEmpty(information) ||
    isCustomFieldDateTimeField2NotEmpty(information) ||
    isCustomFieldCustomListField2NotEmpty(information) ||
    isCustomFieldTextField3NotEmpty(information) ||
    isCustomFieldNumericField3NotEmpty(information) ||
    isCustomFieldBooleanField3NotEmpty(information) ||
    isCustomFieldDateTimeField3NotEmpty(information) ||
    isCustomFieldCustomListField3NotEmpty(information) ||
    isCustomFieldTextField4NotEmpty(information) ||
    isCustomFieldNumericField4NotEmpty(information) ||
    isCustomFieldBooleanField4NotEmpty(information) ||
    isCustomFieldDateTimeField4NotEmpty(information) ||
    isCustomFieldCustomListField4NotEmpty(information) ||
    isCustomFieldTextField5NotEmpty(information) ||
    isCustomFieldNumericField5NotEmpty(information) ||
    isCustomFieldBooleanField5NotEmpty(information) ||
    isCustomFieldDateTimeField5NotEmpty(information) ||
    isCustomFieldCustomListField5NotEmpty(information);  